<template>
    <Line :data="chartData" :options="chartOptions" />
  </template>
  
  <script>
  import { Line } from 'vue-chartjs';
  import { Chart, registerables } from 'chart.js';
  import zoomPlugin from 'chartjs-plugin-zoom';
  import 'chartjs-adapter-date-fns';
  
  Chart.register(...registerables, zoomPlugin);
  
  export default {
    name: 'CycleLengthChart',
    components: { Line },
    props: {
      labels: Array,
      cycleLengthData: Array,
    },
    computed: {
      chartData() {
        return {
          labels: this.labels,
          datasets: [
            {
              label: 'Cycle Time',
              data: this.cycleLengthData,
              borderColor: '#FF6384', // Customize the color
              fill: false,
            },
          ],
        };
      },
      chartOptions() {
        let yMax = undefined;
        if (this.cycleLengthData && this.cycleLengthData.length > 0) {
          const validData = this.cycleLengthData.filter(v => typeof v === 'number' && !isNaN(v));
          validData.sort((a, b) => a - b);
          
          if (validData.length >= 4) {
             const q1 = validData[Math.floor(validData.length * 0.25)];
             const q3 = validData[Math.floor(validData.length * 0.75)];
             const iqr = q3 - q1;
             
             // 3.0 * IQR identifies extreme outliers
             const upperFence = q3 + 3 * iqr; 
             
             const maxVal = validData[validData.length - 1];
             if (maxVal > upperFence) {
                 // Geri kalan veriler için makul bir üst sınır (15% boşluklu)
                 yMax = Math.ceil(upperFence * 1.15);
             }
          }
        }

        return {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2,
          layout: { padding: 10 },
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'hour',
                tooltipFormat: 'yyyy-MM-dd HH:mm:ss',
              },
              ticks: {
                maxTicksLimit: 10,
                autoSkip: true,
              },
            },
            y: {
              beginAtZero: true,
              max: yMax, // Set dynamically calculated max
              grace: '20%', // Grafiğin en tepesine %20 boşluk (offset) bırak
              ticks: {
                autoSkip: true,
              },
            },
          },
          plugins: {
            legend: { display: true, position: 'bottom' },
            zoom: {
              zoom: { wheel: { enabled: true, modifierKey: 'shift' }, pinch: { enabled: true }, mode: 'xy'},
              pan: { enabled: true, mode: 'xy', modifierKey: 'ctrl' },
            },
          },
        };
      },
    },
  };
  </script>
